module.exports = __webpack_public_path__ + "img/19.f10baf30.png";